import styled from "@emotion/styled";
export const StyledIframeDynamicWidthIframeComponent = styled.div`
  margin: auto;
  display: flex;
  justify-content: center;
`;
